import { useState } from "react";
import { Link } from "react-router-dom";

/**
 * Small avatar chip for the Navbar.
 * - Renders the user's Google avatar (`picture`) when available.
 * - Falls back to a mono-lettered initials tile using the user's name/email.
 * Wraps in a link to /preferences so users can manage their account.
 */
export default function UserAvatar({ user }) {
  const [failed, setFailed] = useState(false);
  if (!user) return null;

  const initial =
    ((user.name || user.email || "?").trim()[0] || "?").toUpperCase();
  const src = user.picture || user.google_picture || "";
  const showImage = src && !failed;

  return (
    <Link
      to="/preferences"
      className="shrink-0"
      title={user.name || user.email}
      data-testid="nav-user-avatar"
    >
      {showImage ? (
        <img
          src={src}
          alt={user.name || "You"}
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
          className="w-8 h-8 rounded-full object-cover border border-black/20 hover:border-black transition-colors"
        />
      ) : (
        <div className="w-8 h-8 rounded-full bg-[#111111] text-white flex items-center justify-center font-serif font-black text-sm border border-black hover:bg-[#E63946] hover:border-[#E63946] transition-colors">
          {initial}
        </div>
      )}
    </Link>
  );
}
